import { type RequiredFileModel, type Stored, type UUID } from "@overmap-ai/common"
import { BaseOfflineFileModelApiService } from "@overmap-ai/core"
import { useCallback } from "react"

import { useFetchFileFromFileModel } from "../../hooks/utils"
import { AppSDK } from "../../sdk"
import type { RootState } from "../../store"
import { genericMemo } from "../../utils/optimization"
import { ImageCard } from "./ImageCard"

interface ImageAttachmentCardProps<TAttachment extends UUID<RequiredFileModel>> {
	attachment: Stored<TAttachment>
	onDelete?: (attachment: Stored<TAttachment>) => void
	service: BaseOfflineFileModelApiService<string, TAttachment, RootState, AppSDK>
}

export const ImageAttachmentCard = genericMemo(function <TAttachment extends UUID<RequiredFileModel>>(
	props: ImageAttachmentCardProps<TAttachment>,
) {
	const { attachment, onDelete, service } = props

	const [fetchedFile, failed] = useFetchFileFromFileModel(attachment, service)

	const handleDelete = useCallback(() => {
		onDelete?.(attachment)
	}, [attachment, onDelete])

	return (
		<ImageCard
			size="sm"
			onDelete={handleDelete}
			file={fetchedFile}
			error={failed ? attachment.file_name : undefined}
		/>
	)
})
